module.exports = __webpack_public_path__ + "img/afsorde.4686f765.svg";